/* eslint-disable import/export */
import { ToolScope } from './toolScope';
export class Metadata {
    constructor(ins, outs) {
        this.ins = ins;
        this.outs = outs;
    }
}
(function (Metadata) {
    Metadata.empty = new Metadata(ToolScope.empty, ToolScope.empty);
})(Metadata || (Metadata = {}));
//# sourceMappingURL=metadata.js.map